import { useAuthStore } from "@/lib/auth/AuthStore";
import { useQuery } from "@tanstack/react-query";
import { getPointBalance } from "src/api/wallet";
import { QUERY_KEYS } from "../constants/queryKeys";
const useGetPointBalance = ()=>{
    const { isLoggedIn  } = useAuthStore();
    return useQuery({
        queryKey: [
            QUERY_KEYS.POINT_BALANCE
        ],
        queryFn: getPointBalance,
        enabled: isLoggedIn
    });
};
export default useGetPointBalance;
